import messages from '../locales/messages';
import { FormattedMessage } from 'react-intl';

export default {
  //header
  header: {
    headerTitle: <FormattedMessage {...messages.headerTitle} />,
    headerText: <FormattedMessage {...messages.headerText} />,
  },
  //forms
  forms: {
    title1: <FormattedMessage {...messages.title1} />,
    input1: <FormattedMessage {...messages.input1} />,
    input2: <FormattedMessage {...messages.input2} />,
    input3: <FormattedMessage {...messages.input3} />,
    title2: <FormattedMessage {...messages.title2} />,
    bar1: <FormattedMessage {...messages.bar1} />,
    bar2: <FormattedMessage {...messages.bar2} />,
    upBar1: <FormattedMessage {...messages.upBar1} />,
    upBar2: <FormattedMessage {...messages.upBar2} />,
  },
  //results
  results: {
    resultsTitle: <FormattedMessage {...messages.resultsTitle} />,
    resultsText: <FormattedMessage {...messages.resultsText} />,
    reduce1: <FormattedMessage {...messages.reduce1} />,
    reduce2: <FormattedMessage {...messages.reduce2} />,
    reduce3: <FormattedMessage {...messages.reduce3} />,
    savings: <FormattedMessage {...messages.savings} />,
  },
};
